var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectYourOwnGitRepo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 128,
    viewBox: "0 0 137 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "xk6grrre9a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 137,
    height: 128
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 135,
    height: 127,
    rx: 5.5,
    fill: "#F9F9FB",
    stroke: "#D6DAE4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#xk6grrre9a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.065,
    y: 84.342,
    width: 126.145,
    height: 153.798,
    rx: 6,
    fill: "#fff",
    stroke: "#22283C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.92,
    cy: 93.272,
    rx: 1.971,
    ry: 1.984,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.265,
    cy: 93.272,
    rx: 1.971,
    ry: 1.984,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.61,
    cy: 93.272,
    rx: 1.971,
    ry: 1.984,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.88 58.876a1.718 1.718 0 0 1 0 2.422L45.073 73.104a1.718 1.718 0 0 1-2.422 0L30.784 61.237a1.718 1.718 0 0 1 0-2.422l8.114-8.173 3.087 3.087c-.363.909-.12 2.24 1.15 2.725v7.447c-1.392.545-1.755 2.362-.726 3.391.848.848 2.12.848 2.967 0 .787-.787.969-2.543-.545-3.33v-7.387l2.785 2.846c-.847 2.059 1.817 3.875 3.39 2.24 1.575-1.574-.06-4.117-2.118-3.451l-3.028-2.967c.545-1.635-.968-3.209-2.603-2.664l-3.149-3.088 2.483-2.482c.666-.666 1.756-.666 2.482 0L56.88 58.876z",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectYourOwnGitRepo);
export default __webpack_public_path__ + "static/media/ConnectYourOwnGitRepo.0ee407e147ca8fa25af69abc39ce6ea3.svg";
export { ForwardRef as ReactComponent };